import { replaceFieldsWithValues } from '../replaceFieldsWithValues';
import HowADSCWorks from '../HowADSCWorks';
import Faq from '../Faq';
import Carousel from '../carousel';
import GarageFeatureImageCarousel from '../GarageFeatureCarousel';
import GoogleReviews from '../GoogleReviews';
import CarServices from '../carServices';
import ManualContent from '../ManualContent';
import ImagesWithTitle from '../ImagesWithTitle';
import UserCard from '../UserCard';
import GarageCard from '../GarageCard';
import Headings from '../Headings';
import LoginCard from '../LoginCard';
import PincodeCard from '../Pincode';
import {
    buttonLabels,
    garageCardHeadings,
    rewardTags,
} from '@/components/seoPages/GarageCard/messages';

export function GenericLandingPage(props: any) {
    console.log('GenericLandingPage props', props);
    const {
        ReusableComponent,
        city,
        garage,
        brand = '',
        garageSeoManualdata = {},
        garageData = {},
        reviewData = {},
        first_name,
        cardData,
        rewardDetails,
        garageId,
        isLoggedInServerSide,
        pincode,
        userPolicyType,
        appointmentData,
        pageType,
    } = props;
    const {
        componentName,
        imageUrls,
        servicesImages,
        heading,
        subText,
        stepIcon,
        steps,
        videos,
        logos,
        videoUrls,
        imagesUrl,
        showAssuranceTag,
        landingheading,
        landingCouponHeading,
        landingSubText,
        rewardAvailableMessage,
        policyHolderDescription,
        nonPolicyHolderDescription,
        loginCardHeading,
    } = ReusableComponent;

    console.log('GenericLandingPage props', props);

    const { Manual, Faqs } = garageSeoManualdata;
    const location = garage ? `${garage}, ${city}` : `${city}`;

    switch (componentName) {
        // case 'ImageCarousel':
        //     return (
        //         <Carousel
        //             key="ImageCarousel"
        //             slides={[
        //                 ...videoUrls.map((url: any) => ({
        //                     ...url,
        //                     type: 'video',
        //                 })),
        //                 ...imageUrls.map((url: any) => ({
        //                     ...url,
        //                     type: 'image',
        //                 })),
        //             ]}
        //             videoLength={videoUrls?.length || 0}
        //         />
        //     );
        case 'CarServices':
            return (
                <CarServices
                    heading={replaceFieldsWithValues(
                        rewardDetails?.coupons?.length > 1
                            ? landingCouponHeading
                            : landingheading,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                            userName: first_name || 'there',
                        }
                    )}
                    subText={replaceFieldsWithValues(landingSubText, {
                        location: location,
                        brand: brand,
                        nearYou: 'near you',
                        userName: first_name || 'there',
                    })}
                    servicesImages={servicesImages}
                    logo={garageData?.servicing_brands?.find(
                        (servicing_brand?: any) => {
                            return (
                                brand?.toLocaleLowerCase() ===
                                servicing_brand?.company_name?.toLocaleLowerCase()
                            );
                        }
                    )}
                    logos={logos}
                    isLandingPage={true}
                    cardData={cardData}
                    rewardDetails={rewardDetails}
                    rewardAvailableMessage={rewardAvailableMessage}
                    garageId={garageId}
                    isLoggedInServerSide={isLoggedInServerSide}
                    userPolicyType={userPolicyType}
                    policyHolderDescription={policyHolderDescription}
                    nonPolicyHolderDescription={nonPolicyHolderDescription}
                    pincode={pincode}
                    appointmentData={appointmentData}
                />
            );
        case 'HowADSCWorks':
            return (
                <HowADSCWorks
                    heading={heading}
                    subText={subText}
                    stepIcon={stepIcon}
                    steps={steps}
                />
            );

        case 'ManualContent':
            return Manual ? (
                <ManualContent
                    manualdata={Manual}
                    location={location}
                    brand={brand}
                    nearYou={'near you'}
                    city={city}
                    garage={garage}
                />
            ) : null;
        case 'Faq':
            return Faqs ? (
                <Faq
                    faqs={Faqs}
                    location={location}
                    brand={brand}
                    nearYou={'near you'}
                    city={city}
                    garage={garage}
                />
            ) : null;
        // case 'OurServiceCentres':
        //     return (isCity || isBrand || isGarage) &&
        //         garageList &&
        //         garageList.length > 0 ? (
        //         <OurServiceCentres
        //             heading={replaceFieldsWithValues(
        //                 isCity ? cityHeading : garageHeading,
        //                 {
        //                     location: location,
        //                     brand: brand,
        //                     nearYou: 'near you',
        //                 }
        //             )}
        //             garageList={garageList}
        //             isCity={isCity}
        //             garage={garage}
        //             brand={brand}
        //         />
        //     ) : null;

        case 'ImagesWithTitle':
            return (
                <ImagesWithTitle
                    heading={heading}
                    showAssuranceTag={showAssuranceTag}
                    imagesData={imagesUrl}
                />
            );

        case 'GoogleReviews':
            return garageData ? (
                <GoogleReviews
                    reviewsData={garageData?.garage_review_ratings}
                    garage={garage}
                    reviewData={reviewData}
                />
            ) : null;
        case 'PremiumServices':
            return videos && videos.length > 1 ? (
                <GarageFeatureImageCarousel data={videos} />
            ) : null;
        case 'UserCard':
            return cardData && Object.keys(cardData).length ? (
                <UserCard cardData={cardData} />
            ) : null;

        case 'GarageCard':
            return (
                <GarageCard
                    garageCardDetails={props.garageCardDetails}
                    garageCardHeading={garageCardHeadings.main}
                    buttonLabel={buttonLabels.selectCentre}
                    rewardTag={rewardTags.pickAndDrop}
                />
            );

        case 'Headings':
            return (
                <Headings
                    heading={replaceFieldsWithValues(
                        rewardDetails?.coupons?.length > 1
                            ? landingCouponHeading
                            : landingheading,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                            userName: first_name || 'there',
                        }
                    )}
                    subText={replaceFieldsWithValues(landingSubText, {
                        location: location,
                        brand: brand,
                        nearYou: 'near you',
                        userName: first_name || 'there',
                    })}
                    logo={garageData?.servicing_brands?.find(
                        (servicing_brand?: any) => {
                            return (
                                brand?.toLocaleLowerCase() ===
                                servicing_brand?.company_name?.toLocaleLowerCase()
                            );
                        }
                    )}
                    isLandingPage={true}
                />
            );

        case 'LoginCard':
            return !isLoggedInServerSide ? (
                <LoginCard loginCardTitle={loginCardHeading} />
            ) : null;

        case 'PincodeCard':
            return garageId && isLoggedInServerSide ? (
                <PincodeCard
                    pincode={pincode || ''}
                    isloggedInServerSide={isLoggedInServerSide}
                    pageType={pageType}
                />
            ) : null;

        default:
            return null;
    }
}
